import CodeEditor from "components/CodeEditor";
import { useCheckFileMaxSize } from "components/Environment/useCheckFileMaxSize";
import { EmptystateLockColored, ErrorCircleColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { ConfigElement } from "types/generated";

type IntentProjectEnvironmentMountedFilesTableFileRowProps = {
  item: ConfigElement;
};

const IntentProjectEnvironmentMountedFilesTableFileRow = ({
  item,
}: IntentProjectEnvironmentMountedFilesTableFileRowProps) => {
  const { fileContent, exceedsFileSize, isFileBroken } = useCheckFileMaxSize(item.value ?? "");

  const isSecret = item.writeOnly;

  let content;
  if (exceedsFileSize) {
    content = (
      <EmptyState
        icon={ErrorCircleColored}
        title="File too large"
        caption="We can't display file preview. File is either larger than 0,5MB or in a wrong format."
      />
    );
  } else if (isFileBroken) {
    content = (
      <EmptyState
        margin="large 0"
        icon={ErrorCircleColored}
        title="We couldn't load the file."
        caption="Please try again later."
      />
    );
  } else if (isSecret) {
    content = (
      <EmptyState
        margin="large 0"
        icon={EmptystateLockColored}
        title="This is a secret file"
        caption="This means you can not edit it, only overwrite or upload a new one."
      />
    );
  } else {
    content = (
      <CodeEditor
        autoHeight
        maxAutoHeight={500}
        language="json"
        body={fileContent}
        readOnly
        options={{ overviewRulerLanes: 0 }}
      />
    );
  }

  return (
    <Box padding="x-large" fullWidth>
      {content}
    </Box>
  );
};

export default IntentProjectEnvironmentMountedFilesTableFileRow;
